import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgStar = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 10 9"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.715.878a.3.3 0 0 1 .57 0l.77 2.37a.3.3 0 0 0 .286.207h2.491a.3.3 0 0 1 .176.543L6.993 5.462a.3.3 0 0 0-.11.335l.77 2.37a.3.3 0 0 1-.461.335L5.176 7.038a.3.3 0 0 0-.352 0L2.808 8.502a.3.3 0 0 1-.462-.335l.77-2.37a.3.3 0 0 0-.109-.335L.992 3.998a.3.3 0 0 1 .176-.543h2.491a.3.3 0 0 0 .286-.207z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStar);
export default ForwardRef;
